import React, { useState } from 'react';
import './AutopilotDiffViewer.scss';

// 算 diff 的增/刪行數(排除 +++/--- 檔頭),照搬 autopilot-system RequestDetailPage.jsx 的邏輯
function countDiff(diff) {
  let adds = 0, dels = 0;
  for (const line of (diff || '').split('\n')) {
    if (line.startsWith('+') && !line.startsWith('+++')) adds++;
    else if (line.startsWith('-') && !line.startsWith('---')) dels++;
  }
  return { adds, dels };
}

// GitHub 風格的 unified diff 呈現(+ 綠 / - 紅 / @ 藍)。照搬 autopilot-system 的 DiffBlock.jsx,
// 只是那邊用 MUI Box、這邊沒有 MUI,換成純 CSS class。
function DiffBlock({ diff }) {
  if (!diff) return null;
  return (
    <pre className="adv-diff">
      {diff.split('\n').map((line, i) => {
        const kind = line.startsWith('+') ? 'add' : line.startsWith('-') ? 'del' : line.startsWith('@') ? 'hunk' : '';
        return <div className={`adv-diff-line adv-diff-line--${kind}`} key={i}>{line || ' '}</div>;
      })}
    </pre>
  );
}

function FileDiff({ file, open, onToggle }) {
  const { adds, dels } = countDiff(file.diff);
  return (
    <div className="adv-file">
      <button className="adv-file-head" onClick={onToggle}>
        <span className={`adv-file-chevron ${open ? 'open' : ''}`}>▸</span>
        <span className="adv-file-path">{file.path}</span>
        {file.newFile && <span className="adv-file-tag adv-file-tag--new">新增</span>}
        {file.deletedFile && <span className="adv-file-tag adv-file-tag--del">刪除</span>}
        <span className="adv-file-adds">+{adds}</span>
        <span className="adv-file-dels">−{dels}</span>
      </button>
      {open && <div className="adv-file-body"><DiffBlock diff={file.diff} /></div>}
    </div>
  );
}

/** 更動檔案清單——每檔可收合。單檔預設展開;多檔預設全收合 + 全部展開/收合。 */
const AutopilotDiffViewer = ({ files }) => {
  const [openPaths, setOpenPaths] = useState(() => new Set(files.length === 1 ? [files[0].path] : []));
  const allOpen = openPaths.size === files.length;
  const toggle = (path) => setOpenPaths((prev) => {
    const next = new Set(prev);
    next.has(path) ? next.delete(path) : next.add(path);
    return next;
  });
  const toggleAll = () => setOpenPaths(allOpen ? new Set() : new Set(files.map((f) => f.path)));

  if (files.length === 0) return null;

  return (
    <div className="adv-root">
      <div className="adv-header">
        <span className="adv-count">更動檔案 {files.length}</span>
        {files.length > 1 && <button className="adv-toggle-all" onClick={toggleAll}>{allOpen ? '全部收合' : '全部展開'}</button>}
      </div>
      <div className="adv-list">
        {files.map((f) => <FileDiff key={f.path} file={f} open={openPaths.has(f.path)} onToggle={() => toggle(f.path)} />)}
      </div>
    </div>
  );
};

export default AutopilotDiffViewer;
